import styled from "styled-components";
import { Props } from "./types";
import { color, space, fontSize } from "styled-system";

export const StyledTitle = styled.div<Props>`
  ${color}
  ${space}
  font-family: Poppins;
  font-size: 32px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: left;
  ${fontSize}
`;
